<template>
	<div class="mt-2">
		<canvas height="200" id="write-board" @mousedown.prevent="writeStart" @mousemove.prevent="writing"
			@mouseup.prevent="writeEnd" @mouseleave.prevent="writeEnd" @touchstart="writeTouchStart"
			@touchmove.prevent="touchWriting" @touchend="writeEnd"></canvas>
		<div class="my-2 d-flex">
			<el-button type="warning" class="other-btn"  @click="initBoardContent">清除</el-button>
		</div>


		<!-- <v-dialog v-model="dialog" max-width="290">
			<v-card>
				<v-card-title class="text-h5">
					提示
				</v-card-title>
				<v-card-text>
					确认签名？一经确认无法更改。
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="green darken-1" text @click="dialog = false">
						取消
					</v-btn>
					<v-btn color="green darken-1" text @click="complete">
						确定
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isWriting: false,
				dialog: false,
				boardTop: 0
			}
		},
		methods: {
			// 确定
			complete() {
				this.dialog = false
				let pic = document.querySelector('#write-board').toDataURL("image/jpeg", 0.7);
				this.$emit('complete', pic)
			},
			getSign() {
				return document.querySelector('#write-board').toDataURL("image/jpeg", 0.7);
			},
			// pc操作
			writeStart(e) {
				this.isWriting = true
				this.ctx.moveTo(e.layerX, e.layerY)
			},
			writing(e) {
				if (!this.isWriting) return
				this.ctx.lineWidth = 5;
				this.ctx.strokeStyle = '#000';
				this.ctx.lineTo(e.layerX, e.layerY)
				this.ctx.stroke()
			},
			writeEnd(e) {
				this.isWriting = false
			},
			// 移动端操作
			writeTouchStart(e) {
				let bcr = this.board.getBoundingClientRect(),
					touch = e.changedTouches[0];
				this.boardTop = bcr.top
				this.isWriting = true
				this.ctx.moveTo(touch.clientX, touch.clientY - this.boardTop)
			},
			touchWriting(e) {
				if (!this.isWriting) return
				let touch = e.changedTouches[0];
				this.ctx.lineWidth = 5;
				this.ctx.strokeStyle = '#000';
				this.ctx.lineTo(touch.clientX, touch.clientY - this.boardTop)
				this.ctx.stroke()
			},
			setBoardSize() {
				let cv = document.querySelector('#write-board'),
					cvp = cv.parentElement;
				cv.width = cvp.clientWidth
				// cv.height = cv.width * 0.618
				this.board = cv
				this.ctx = this.board.getContext('2d')
			},
			initBoardContent() {
				this.ctx.beginPath()
				this.ctx.clearRect(0, 0, this.board.width, this.board.height);
				this.ctx.fillStyle = "#fff";
				this.ctx.fillRect(0, 0, this.board.width, this.board.height);
				this.ctx.lineWidth = 1
				this.ctx.closePath()
			}
		},
		created() {
			// this.setCanvasSize()
		},
		mounted() {
			this.setBoardSize()
			this.initBoardContent()
			window.addEventListener('resize', () => {
				var imgData = this.ctx.getImageData(0,0,this.board.width,this.board.height);
				this.setBoardSize()
				this.initBoardContent()
				this.ctx.putImageData(imgData,0,0);
			})
		}
	}
</script>

<style scoped lang="scss">
	.confirm-btn {
		flex: 3;
	}
	.other-btn{
		flex: 1;
	}
	#write-board {
		background-color: #fff;
		box-shadow: 3px 3px 15px -6px #001;
	}
</style>
